<template>
  <div class="content-container">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      width="30%"
      :before-close="handleClose"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-width="80px"
        label-position="top"
      >
        <el-form-item label="转交人:" prop="userList">
          <my-person v-model="form.userList" :limit="limit" :disabled-users="disabledUsers" :show-users="true">
            <el-button size="small"><i class="el-icon-plus" />
              选择用户
            </el-button>
          </my-person>
          <!-- <div class="card">
            <img src="@/assets/upload.png" alt="">
            <span>张小五</span>
            <i class="el-icon-close" />
          </div> -->
        </el-form-item>
        <el-form-item label="备注:" prop="note">
          <el-input
            v-model="form.note"
            required
            maxlength="500"
            :rows="4"
            show-word-limit
            type="textarea"
            placeholder="请输入备注信息"
            @keydown.enter.native="handleTextareaKeydown"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button :loading="loading" type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: ''
    },
    limit: {
      type: Number,
      default: 0
    },
    disabledUsers: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      form: {
        note: '',
        userList: []
      },
      rules: {
        note: [{ required: true, message: '请输入备注信息', trigger: 'blur' }],
        userList: [{ required: true, message: '请选择转交人', trigger: 'blur' }]
      },
      operateType: null
    }
  },
  computed: {},
  watch: {
    'form.userList': {
      handler: function(val) {
        console.log('val', val)
        if (val.length !== 0) {
          this.$refs.form.validateField('userList')
        }
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    // 限制输入框换行操作
    handleTextareaKeydown() {
      const e = window.event || arguments[0]
      if (e.key === 'Enter' || e.code === 'Enter' || e.keyCode === 13) {
        e.returnValue = false
        return false
      }
    },
    openDialog(obj) {
      this.dialogVisible = true
    },
    handleClose(done) {
      console.log('handleClose')
      this.$set(this.form, 'userList', [])
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
      this.dialogVisible = false
    },
    submit() {
      switch (this.title) {
        case '转签':
          this.operateType = 8
          break
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('submitForm', this.operateType, this.form, () => {
            this.loading = false
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~@/views/taskManage/css/dialog.scss";
.card {
  width: 118px;
  height: 32px;
  background: #eeeeee;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  margin-top: 10px;
  &:hover {
    background: rgba(44, 81, 239, 0.1);
    color: #2c51ef;
  }
  img {
    width: 24px;
    height: 24px;
    border-radius: 50%;
  }
}
</style>
